import { createAction } from '@reduxjs/toolkit';
import { SET_ACTIVE_PRODUCT, ActiveProductState } from '../types';

export const setActiveProduct =
  createAction<ActiveProductState>(SET_ACTIVE_PRODUCT);
